import state from './places.state'
import mutations from './places.mutations'
import actions from './places.actions'
import getters from './places.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
